import React from "react";
import { Fragment } from "react";
import SitemapBanner from "../Components/Sitemap/SitemapBanner";
import SitemapContent from "../Components/Sitemap/SitemapContent";
import { Helmet } from "react-helmet";

function Sitemap() {
  const metaData = {
    title: 'Sitemap | Salaam Takaful - Complete Website Navigation',
    description: 'Browse our complete sitemap to find all pages, products, services, and resources available on Salaam Takaful website. Easy navigation for all our Islamic insurance solutions.'
  }
  return (
    <Fragment>
      <Helmet>
        <title>{metaData.title}</title>
        <meta name="description" content={metaData.description} />
      </Helmet>
      <div className="container-fluid faderight">
        <div className="row">
          <SitemapBanner />
          <SitemapContent />
        </div>
      </div>
    </Fragment>
  );
}

export default Sitemap;
